module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/super-touch-video-zh-mobile.56eec63d.mp4";